$(function () {
  $('.obis-slider-slider').each(function (i, e) {
    var element = $(this);
    var carousel = element.children('.carousel');

    var slidesToShow = element.data('slides-to-show');
    var forceSlidesToShow = element.data('force-slides-to-show');

    var config = {
      accessibility: element.data('accessibility'),
      adaptiveHeight: (Neos.inBackend() ? false : element.data('adaptive-height')),
      autoplay: (Neos.inBackend() ? false : element.data('autoplay')),
      autoplaySpeed: element.data('autoplay-speed'),
      arrows: element.data('arrows'),
      // appendArrows: 
      // appendDots: 
      prevArrow: '<button type="button" class="slick-prev">Previous</button>',
      nextArrow: '<button type="button" class="slick-next">Next</button>',
      centerMode: element.data('center-mode'),
      centerPadding: (isset(element.data('center-padding'), 'number') ? parseInt(element.data('center-padding'))+'px' : '50px'),
      cssEase: 'ease',
      dots: element.data('dots'),
      dotsClass: 'slick-dots pagination',
      draggable: element.data('draggable'),
      fade: element.data('fade'),
      easing: 'linear',
      infinite: (Neos.inBackend() ? false : element.data('infinite')),
      lazyLoad: element.data('lazy-load'),
      pauseOnFocus: element.data('pause-on-focus'),
      pauseOnHover: element.data('pause-on-hover'),
      pauseOnDotsHover: element.data('pause-on-dots-hover'),
      rows: element.data('rows'),
      // slide: 
      slidesPerRow: element.data('slides-per-row'),
      slidesToShow: 1, // element.data('slides-to-show'),
      slidesToScroll: element.data('slides-to-scroll'),
      speed: element.data('speed'),
      swipe: element.data('swipe'),
      swipeToSlide: true,
      touchMove: element.data('touch-move'),
      touchThreshold: 5,
      useCSS: true,
      useTransform: true,
      variableWidth: forceSlidesToShow ? (slidesToShow > 1) : element.data('variable-width'),
      vertical: element.data('vertical'),
      rtl: element.data('rtl'),
      waitForAnimate: true,
    };

    if (isset((prevArrow = element.data('prev-arrow')))) {
      config.prevArrow = '<button type="button" class="slick-prev arrow-custom">' + prevArrow + '</button>';
    }

    if (isset((nextArrow = element.data('next-arrow')))) {
      config.nextArrow = '<button type="button" class="slick-next arrow-custom">' + nextArrow + '</button>';
    }
    
    this.carousel = carousel.slick(config);

    var track = carousel.find('.slick-track');
    var slidesToShowTargetProperty = (forceSlidesToShow === true ? "width" : "min-width");
    
    function resizeSlides() {
      if (slidesToShow > 1) {
        var proportion = Math.floor(carousel.innerWidth() / slidesToShow);
        track.find('.slick-slide').each(function (i, e) {
          var leftMargin = parseInt($(this).css('margin-left'));
          var rightMargin = parseInt($(this).css('margin-right'));
          $(this).css(slidesToShowTargetProperty, (proportion - leftMargin - rightMargin));
        });
      } else if (forceSlidesToShow === true) {
        track.find('.slick-slide').css('width', '100%');
      }

      if (config.adaptiveHeight === false) {
        track.find('.slick-slide .inner').css('height', '');

        var slides = track.find('.slick-slide').get();
        var sliderHeight = 0;

        for (var i = 0; i < slides.length; i++) {
          var height = $(slides[i]).innerHeight();
          if (height > sliderHeight) {
            sliderHeight = height;
          }
        }

        track.find('.slick-slide .inner').css('height', sliderHeight + 'px');
      }

      carousel.slick('setPosition');
    }

    $(window).on('resize', resizeSlides);
    resizeSlides();
  });
});